// extracted by mini-css-extract-plugin
export default {"container":"Ko-z","heading":"Lo-z","text":"Mo-z","info":"No-z","link":"Oo-z","fullMaxWidth":"Po-z"};